
const LoadingReport = () => { 
    return (
        <svg xmlns="http://www.w3.org/2000/svg"  
        style={{margin: 'auto',  display: 'block'}} width="177px" height="177px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
            <circle cx="50" cy="50" r="30" stroke="#087df2" stroke-width="8" fill="none"></circle>
            <circle cx="50" cy="50" r="30" stroke="#ffffff" stroke-width="6" stroke-linecap="round" fill="none">
                <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.9174311926605504s" values="0 50 50;180 50 50;720 50 50" keyTimes="0;0.5;1"></animateTransform>
                <animate attributeName="stroke-dasharray" repeatCount="indefinite" dur="0.9174311926605504s" values="15.079644737231007 173.41591447815657;96.13273519984767 92.3628240155399;15.079644737231007 173.41591447815657" keyTimes="0;0.5;1"></animate>
            </circle>
        </svg> 
    )
} 
export default LoadingReport;